const KRW = new Intl.NumberFormat('ko-KR');
const DT = new Intl.DateTimeFormat('ko-KR', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});

export const formatKRW = (n: number) => `${KRW.format(n)}원`;
export const formatDateTime = (iso: string | Date) =>
  DT.format(typeof iso === 'string' ? new Date(iso) : iso);
